const common = {
  // Nav
  nav_home: 'ホーム',
  nav_books: '書籍',
  nav_courses: 'コース',
  nav_mentorship: 'Mentoria SÍLEX',
  nav_webinars: 'ウェビナー',
  nav_about: '私たちについて',
  nav_contact: 'お問い合わせ',
  nav_links: 'リンク',
  nav_enter: 'ログイン',
  nav_my_courses: 'マイコース',
  nav_community: 'コミュニティ',
  nav_ranking: 'ランキング',
  nav_certificates: '証明書',
  // Auth
  auth_login_title: 'アカウントにアクセス',
  auth_login_subtitle: 'メールまたはソーシャルネットワークでサインイン',
  auth_register_title: 'アカウントを作成',
  auth_register_subtitle: 'コースにアクセスするために登録してください',
  auth_forgot_title: 'パスワードを回復',
  auth_forgot_subtitle: 'メールにリンクを送信します',
  auth_tab_login: 'ログイン',
  auth_tab_register: 'アカウント作成',
  auth_email: 'メールアドレス',
  auth_password: 'パスワード',
  auth_name: 'フルネーム',
  auth_confirm_password: 'パスワードを確認',
  auth_forgot_link: 'パスワードを忘れた',
  auth_btn_login: 'メールでログイン',
  auth_btn_register: '無料アカウント作成',
  auth_btn_forgot: '回復リンクを送信',
  auth_or: 'または続ける',
  auth_or_register: 'または登録する',
  auth_google: 'Googleで続ける',
  auth_facebook: 'Facebookで続ける',
  auth_apple: 'Appleで続ける',
  auth_back_login: '← ログインに戻る',
  auth_terms: 'ログインすることで、当社の',
  auth_terms_link: '利用規約',
  auth_privacy_link: 'プライバシーポリシー',
  auth_and: 'および',
  // Livros page
  livros_hero_badge: '完全ライブラリ',
  livros_hero_title: '電子書籍＆書籍',
  livros_hero_subtitle: '知識が人を変える。次の一冊を選んで、成長の旅を始めよう。',
  livros_filter_all: 'すべて',
  livros_filter_pdf: 'PDF電子書籍',
  livros_filter_print: '印刷版',
  livros_search_placeholder: '書籍またはテーマを検索...',
  livros_btn_buy: '今すぐ購入',
  livros_btn_amazon: 'Amazon',
  livros_btn_details: '詳細を見る',
  livros_pages: 'ページ',
  livros_readers: '読者',
  livros_cta_title: 'すべての書籍にアクセスしたいですか？',
  livros_cta_subtitle: 'SB Familyに登録して、全ライブラリ＋コース＋グループメンタリングに無制限アクセスできます。',
  livros_cta_btn: 'サブスクリプションを探る',
  livros_stat_books: '出版書籍',
  livros_stat_readers: '満足した読者',
  livros_stat_rating: '平均評価',
  livros_stat_editions: '改訂版',
  // Language
  lang_label: '言語',
  lang_pt: 'Português',
  lang_es: 'Español',
  lang_en: 'English',
  lang_fr: 'Français',
  lang_de: 'Deutsch',
  lang_it: 'Italiano',
  lang_ja: '日本語',
};

export default common;
